import { RouteObject } from "../../interfaces/navigation";
import React from "react";

const EntryPoint = React.lazy(() => import("../../containers/Utilitarios/UtilitariosContainer"));

export const utilitariosRoutes: RouteObject[] = [
    {
        title: "Comerciales",
        path: "/comerciales",
        component: <EntryPoint/>
    }
];